if (!window.rumiHeaderMenusReady) {
  window.rumiHeaderMenusReady = true;
  document.addEventListener('click', event => {
    document.querySelectorAll('.rumi-header .store-nav details[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rumi-header .store-nav details[open]').forEach(menu => {
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
      menu.open = false;
    });
  });
}

if (!window.rumiNavigationPointerReady) {
  window.rumiNavigationPointerReady = true;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('pointermove', event => {
    if (event.pointerType === 'touch' || reducedMotion.matches) return;
    const nav = event.target.closest('.rumi-header--animated .store-nav');
    if (!nav) return;
    const bounds = nav.getBoundingClientRect();
    nav.style.setProperty('--pointer-x', `${event.clientX - bounds.left}px`);
    nav.style.setProperty('--pointer-y', `${event.clientY - bounds.top}px`);
    nav.classList.add('is-pointer-active');
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    const nav = event.target.closest('.rumi-header--animated .store-nav');
    if (nav && !nav.contains(event.relatedTarget)) nav.classList.remove('is-pointer-active');
  }, { passive: true });
}

// Native modal dialogs provide focus containment, Escape and background isolation.
if (!window.rumiMobileNavigationReady) {
  window.rumiMobileNavigationReady = true;
  const initialized = new WeakSet();
  const mobile = matchMedia('(max-width: 749px)');
  const reset = (dialog, toggle) => {
    document.documentElement.classList.remove('rumi-drawer-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open navigation menu');
    if (mobile.matches && toggle.isConnected) toggle.focus();
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest('.rumi-mobile-menu-toggle');
    if (!toggle || !mobile.matches) return;
    const header = toggle.closest('.rumi-header');
    const dialog = header.querySelector('.rumi-mobile-drawer');
    if (!dialog || dialog.open) return;
    const categories = dialog.querySelector('[data-drawer-categories]');
    categories.replaceChildren();
    const sources = header.querySelector('.store-nav .rumi-category-dropdown')
      ? [header.querySelector('.store-nav .rumi-category-dropdown')]
      : [...header.querySelectorAll('.store-nav > div')];
    sources.forEach(source => {
      const copy = source.cloneNode(true);
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      if (copy.matches('details')) copy.open = false;
      copy.querySelectorAll('details').forEach(node => node.open = false);
      categories.append(copy);
    });
    if (!initialized.has(dialog)) {
      initialized.add(dialog);
      dialog.addEventListener('close', () => reset(dialog, toggle));
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        const outside = event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
        if (outside || event.target.closest('.rumi-drawer-close, a')) dialog.close();
      });
    }
    dialog.showModal();
    document.documentElement.classList.add('rumi-drawer-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close navigation menu');
    dialog.querySelector('.rumi-drawer-close').focus();
  });
  mobile.addEventListener('change', () => {
    document.querySelectorAll('.rumi-mobile-drawer[open]').forEach(dialog => dialog.close());
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.rumi-mobile-drawer[open]').forEach(dialog => {
      dialog.close();
      document.documentElement.classList.remove('rumi-drawer-open');
    });
  });
}
